module.exports = __webpack_public_path__ + "media/images/plans/photo_chapel/hall-list/plan-photowedding-lineup-tokai-4-b4e87594ea17cbfcea42f1a40e95c14c.png";